import React, { Component } from 'react'
import Slider from 'react-slick';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Custom arrow components
const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="news-arrow news-prev" onClick={onClick}>
            ←
        </button>
    );
};

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="news-arrow news-next" onClick={onClick}>
            →
        </button>
    );
};

class NewsPublished extends Component {
    componentDidMount() {
        Fancybox.bind("[data-fancybox='newspaper-gallery']", {
            animated: true,
            showClass: "fancybox-zoomIn",
            hideClass: "fancybox-zoomOut",
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: [],
                    right: ["close"],
                },
            },
        });
    }

    componentWillUnmount() {
        Fancybox.destroy();
    }

    render() {
        const settings = {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            arrows: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        initialSlide: 2,
                        arrows: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        };

        const newspapers = [
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper31.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper20.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper21.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper22.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper23.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper24.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper25.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper26.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper27.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper28.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper29.jpg"),
            require("../assets/img/whatsinaname/gallery/innerpage/NewsPaper/paper30.jpg")
        ];

        return (
            <section className="brand-logo-wrapper vVedioBlock news-slider-section">
                <div className="container">
                    <div className="row">
                        <div className='col-md-12 text-center'>
                            <h2>Published in Newspapers</h2>
                        </div>
                        <div className="col-md-12">
                            <Slider className="brand-logo-carousel" {...settings}>
                                {newspapers.map((img, index) => (
                                    <div key={index} className="single-brand-logo videoSpace">
                                        <a
                                            href={img}
                                            data-fancybox="newspaper-gallery"
                                            data-caption={`Newspaper ${index + 1}`}
                                        >
                                            <div style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                                <img src={img} alt={`newspaper ${index + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'pointer' }} />
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default NewsPublished
